/* globals API_PREFIX, API_VERSION */

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import LoadingView from 'core/views/loading';


export default Backbone.View.extend({
  events: {
    'click input[type="submit"]': 'submitReset'
  },

  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.$email = $('input[name="email"]', this.$el);
    this.$error = $('.error', this.$el);
  },

  submitReset: function (ev) {
    ev.preventDefault();
    var self = this;
    var userApiUri = window.Urls['accounts_api:api_dispatch_list']({
      api_name: API_VERSION,
      resource_name: 'user',
    });

    const loadingView = new LoadingView({ el: $('body') });
    loadingView.show();
    $.post(API_PREFIX + userApiUri + 'password_reset/', {
      email: this.$email.val(),
    }, function (data) {
      if (data.success) {
        // Success
        const opts = { 'native': true };
        window.location = window.Urls.password_reset_done({}, opts);
      } else {
        // Failure
        self.$error.removeClass('hide');
        self.$error.html('<strong>Oops!</strong> ' + data.email[0]);
        loadingView.hide();
      }
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/password_reset.js